export enum SortDirection {
  DEFAULT = 0,
  DESC = 1,
  ASC = 2
}
